import React, { Component } from "react"
import PropTypes from "prop-types"

class TableHeader extends Component {
  render() {
    const { title, handleClickEvent, isSorted, isAscending } = this.props

    const createTitleSpan = (title, isSorted, isAscending) => {
      if (!isSorted) return <span>{title}</span>
      if (isAscending)
        return (
          <span>
            {title} <i className="fa fa-sort-asc" />
          </span>
        )
      return (
        <span>
          {title} <i className="fa fa-sort-desc" />
        </span>
      )
    }

    const sortByColumn = () => {
      handleClickEvent(isAscending)
    }

    return (
      <th onClick={sortByColumn} style={{ cursor: "pointer" }}>
        <div>{createTitleSpan(title, isSorted, isAscending)}</div>
      </th>
    )
  }
}

TableHeader.propTypes = {
  title: PropTypes.string.isRequired,
  handleClickEvent: PropTypes.func,
  isSorted: PropTypes.bool,
  isAscending: PropTypes.bool
}

export default TableHeader



// WEBPACK FOOTER //
// ./src/components/charts/nine-box-grid/TableHeader.jsx